export default __webpack_public_path__ + "static/media/products-elevatexswarovski-comp.6c61fd8d.png";